module.exports = __webpack_public_path__ + "img/step_3-1.b185d384.png";